import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/radio.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import * as propsUtils from '../../packages/props-utils/props-utils.js';
import { InnerRefPropType } from '../../packages/props-utils/prop-types.js';
import { InputInfoChildren, InputInfo } from '../_atoms/input-info/input-info.js';
import { inputLabelValidator } from '../../prop-types-validators/input-label-validator.js';
import '../_atoms/inline-label/inline-label.js';
import { InputField } from '../_atoms/input-field/input-field.js';
import '../_atoms/nav-elem/nav-elem.js';
import { Injecss } from '../../packages/injecss/injecss.js';

const bem = new HoneyBem('radio', styles);
function Radio(_a) {
  var {
      extraClasses,
      id,
      innerRef,
      label,
      name,
      value,
      disabled,
      valid,
      info,
      small = false,
      'aria-describedby': ariaDescribedBy
    } = _a,
    rest = __rest(_a, ["extraClasses", "id", "innerRef", "label", "name", "value", "disabled", "valid", "info", "small", 'aria-describedby']);
  return /*#__PURE__*/React.createElement("div", {
    className: bem.b({
      disabled,
      error: valid === false,
      sm: small
    }, extraClasses)
  }, /*#__PURE__*/React.createElement(InputField, Object.assign({
    ref: innerRef,
    id: id,
    type: "radio",
    value: value,
    name: name,
    disabled: disabled,
    className: bem.e('input'),
    "aria-describedby": propsUtils.handleAriaDescribedBy(id, {
      info,
      ariaDescribedBy
    })
  }, rest)), /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: bem.e('label')
  }, label), info && (/*#__PURE__*/React.createElement(InputInfo, {
    id: id,
    className: bem.e('info')
  }, info)));
}
Radio.displayName = 'Radio';
Radio.propTypes = {
  extraClasses: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  innerRef: InnerRefPropType,
  label: inputLabelValidator('Radio'),
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  disabled: PropTypes.bool,
  valid: PropTypes.bool,
  info: InputInfoChildren,
  small: PropTypes.bool
};
var Radio$1 = Injecss(Radio, styles);

export { Radio, Radio$1 as default };
